export const sortOrderKeys = ["asc", "desc"] as const;

export type SortOrder = (typeof sortOrderKeys)[number];

export const isSortOrder = (value: string): value is SortOrder => {
    return sortOrderKeys.includes(value as SortOrder);
};
